import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        pTeal: colors.teal.lighten4,
        lightTeal: colors.teal.lighten5,
        cyan: colors.cyan.lighten4,
        lightGrey: colors.grey.lighten3,
        whiteGrey: colors.grey.lighten5,
      },
    },
  },
});
